<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="600px"
    class="sign-modal"
    @close="onChange"
  >
    <div slot="title">{{ $t('shop-site::emailSign::title') }}</div>

    <el-form class="email-body" ref="formSign" :model="params" :rules="rules" label-width="100px" v-loading="loading">
      <div class="sec-box no-bg">
        <el-form-item :label="$t('shop-site::emailSign::form_email') + '：'">
          {{ params.outServer }}
        </el-form-item>
        <el-form-item :label="$t('shop-site::emailSign::form_turn') + '：'" prop="signatureStatus">
          <el-switch v-model="params.signatureStatus" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('shop-site::emailSign::form_content') + '：'" prop="signature" class="label-line">
          <RichEditor v-model="params.signature" :placeholder="$t('shop-site::emailSign::placeholder_content')" />
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="saveLoading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { EMAIL_TYPE, PROTOCOL } from '@/config'
import { editSignature } from '@/server/after-sales.js'
import RichEditor from '@/components/rich-editor'
import { getShopList } from '@/server/shopList.js'
import { getAuthAllUser } from '@/server/system.js'
export default {
  name: 'modal-email',
  components: {
    RichEditor
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible (bool) {
      this.show = bool
      const data = this.drawRow
      if (data.type === 'add') {
        this.$refs.form.resetFields()
      } else {
        this.params = {
          ...this.params,
          ...data.item,
          signatureStatus: Boolean(data.item.signatureStatus)
        }
      }
      this.$nextTick(() => this.$refs.formSign.clearValidate())
    },
    drawRow: {
      handler: function (data) {
        console.log(data)
      },
      deep: true
    }
  },
  data () {
    return {
      loading: false,
      saveLoading: false,
      emailTypes: EMAIL_TYPE,
      protocols: PROTOCOL,
      shopIds: [],
      users: [],
      rules: {
        // inAccountType: [{ required: true, message: '请选择服务器类型', trigger: 'blur' }],
        // inServer: [{ required: true, message: '请选择服务器地址', trigger: 'blur' }],
        // inPort: [{ required: true, message: '请输入服务器端口号', trigger: 'blur' }]
      },
      show: false,
      params: {
        signatureStatus: '',
        signature: ''
      }
    }
  },
  mounted () {
    this.getLeaderList()
    this.getShopListInfo()
  },
  methods: {
    async getLeaderList () {
      this.loading = true
      const { data } = await getAuthAllUser({userId: this.$store.state.user.merchantId})
      if (data.code === this.$code) {
        this.users = data.data.map(item => {
          return {
            label: item.userName,
            value: item.userId
          }
        })
      }
      this.loading = false
    },
    async getShopListInfo () {
      this.loading = true
      const { data } = await getShopList({
        pageNum: 1,
        pageSize: 10000
      })
      if (data.code === this.$code) {
        this.shopIds = data.data.items.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
      }
      this.loading = false
    },
    onChange () {
      this.$emit('change', false)
    },
    onSave () {
      this.$refs['formSign'].validate(async valid => {
        if (valid) {
          const params = {
            signatureStatus: Number(this.params.signatureStatus),
            signature: this.params.signature
          }
          if (this.drawRow.type === 'edit') {
            params.id = this.params.id
          }
          this.saveLoading = true
          const { data } = await editSignature(params)
          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('change', false)
            this.$emit('save')
          }
          this.saveLoading = false
        }
      })
    },
    handleCheck (type) {
      this.params.type = type
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    max-height: 550px;
    overflow-y: auto;
  }
}
.sign-modal {
  .email-body {
    .input-item {
      width: 100%;
    }
  }
  .sec-header {
    padding: 0 0 12px 0;
    border-bottom: 1px solid #dcdfe6;
    margin-bottom: 16px;
  }
  .sec-box {
    background-color: #f1f1f1;
  }
  .no-bg {
    background-color: inherit;
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
  .label-line {
    ::v-deep {
      .el-form-item__content {
        margin-left: 0 !important;
      }
      .tox-tinymce {
        width: 100%;
      }
    }
  }
}
</style>
